import React from 'react';
import ReactDOM from 'react-dom/client';
import { I18nextProvider } from 'react-i18next';
import App from './App';
import i18n from './i18n';
// import TestApp from './TestApp';


window.piRenderReactAppLocationMap = window.piRenderReactAppLocationMap
  || function piRenderReactAppLocationMap(appConfig) {
      const renderNode = document.getElementById(appConfig.containerId);
      const locale = appConfig.locale;

      //remove the loader node, if any
      const loaderNode = document.getElementById(appConfig.containerId + '-loader');
      if (loaderNode) {
          loaderNode.remove();
      }

      if (!renderNode) {
          console.error('Comments: No render node found.', appConfig);

          return;
      }

      //replace snippet with app node
      const appNode = document.createElement('div');
      renderNode.replaceWith(appNode);

      const root = ReactDOM.createRoot(appNode);

      root.render(
          <React.StrictMode>
              <I18nextProvider i18n={i18n}>
                  <App locale={locale} />
              </I18nextProvider>
          </React.StrictMode>,
      );
  };

if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
    window.piRenderReactAppLocationMap({
        containerId: 'schuler_company_location_map',
        // Custom language
        locale: 'en',
    });
}
